<!-- HEADER -->
<h2 class="text-center font-header-auth mb-4"> {{'step1.title' | translate | uppercase }} </h2>

<div class="col-10 m-auto">
    <hr class="text-muted mb-4">
</div>

<!-- SUBHEADER -->
<p class="col-10 mx-auto text-center font-primary">{{'step1.subheader' | translate }}</p>


<!-- INFO -->
<div class="text-center mb-4">
    <p class="font-primary mb-4">{{'step1.description' | translate }}</p>

    
</div>

<!-- FORM CONTROL -->
<form autocomplete="off">   
    <!-- Property Seacrh --> 
    <div class="row justify-content-center mb-4">
        <div class="col-10">
            <label for="" class="form-label font-label-auth">{{'step1.step1' | translate }}</label>
            <mat-select class="form-control text-center input-gbl"
                style="padding-top: 10px;"
                (selectionChange)="changeResidentialUnit($event)" 
                placeholder="{{'signup.select1' | translate }}">                
                <mat-option [value]="prop.id_propierty_unit" *ngFor="let prop of propiedades"> {{prop.name_propierty_unit}} </mat-option>

            </mat-select>
        </div>
    </div>
    
    <!-- Unite Number --> 
    <div class="row justify-content-center mb-4">
        <div class="col-10">
            <label for="" class="form-label font-label-auth">{{'step1.step2' | translate }}</label>
            <mat-select class=" form-control text-center input-gbl" 
                style="padding-top: 10px;"
                (selectionChange)="selectUnit($event)" 
                placeholder="{{'signup.select2' | translate }}">
                <mat-option [value]="unit.id_unit" *ngFor="let unit of units"> {{unit.unit}} </mat-option>

            </mat-select>
        </div>
    </div>

    
    <!-- BUTTON SUBMIT -->
    <div class="text-center mb-4">
        <button
            type="button"
            class="btn-secondary-gbl"
            routerLink="/auth/sign-up">
            {{'buttons.back' | translate | uppercase }}
        </button>
        <button
            type="submit"
            class="btn-primary-gbl"
            routerLink="/auth/step-2">
            {{'buttons.search' | translate | uppercase }}
        </button>
    </div>

</form>
